import React from 'react';

import { MasterLayout } from 'src/layout/MasterLayout';

import { NotFound } from './NotFound';

export const NotFoundPage = () => {
    return (
        <MasterLayout>
            <NotFound />
        </MasterLayout>
    );
};
